<script>
export default {
  name: 'ReportsViewer',
  data() {
    return {
      products : [],
      providers : [],
      expenseObjects : [],
      inventoryLocations : [],
    }
  }
}

</script>

<template>
<div></div>
</template>

<style>

</style>